import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/feature/Logo';
import { countryCodes } from '@/mocks/countryCodes';

export default function LoginPage() {
  const [formData, setFormData] = useState({ countryCode: '+961', phone: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock login - would connect to Supabase Auth in production
    alert('Login functionality will be connected to authentication backend.');
  };

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Logo size="md" />
        </div>

        {/* Card */}
        <div className="bg-background-100 border border-primary-800/20 rounded-2xl p-6 md:p-8">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 text-center mb-2">
            Welcome Back
          </h1>
          <p className="text-foreground-400 text-sm text-center mb-8 font-body">
            Sign in to access your TMT account
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="phone" className="block font-label text-xs tracking-wider uppercase text-foreground-300 mb-2">
                Mobile Number
              </label>
              <div className="flex gap-2">
                <select
                  id="countryCode"
                  value={formData.countryCode}
                  onChange={(e) => setFormData({ ...formData, countryCode: e.target.value })}
                  className="w-[120px] flex-shrink-0 px-3 py-3 bg-background-50 border border-primary-800/30 rounded-lg text-foreground-100 text-sm font-body focus:outline-none focus:border-primary-500 transition-colors"
                >
                  {[...countryCodes].sort((a, b) => a.country.localeCompare(b.country)).map((c) => (
                    <option key={c.code} value={c.code}>
                      {c.code} {c.country}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  id="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  className="flex-1 px-4 py-3 bg-background-50 border border-primary-800/30 rounded-lg text-foreground-100 text-sm font-body placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                  placeholder="Enter your mobile number"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block font-label text-xs tracking-wider uppercase text-foreground-300 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-primary-800/30 rounded-lg text-foreground-100 text-sm font-body placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors pr-12"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  <i className={`ri-${showPassword ? 'eye-off' : 'eye'}-line`} />
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" className="w-4 h-4 accent-primary-500 rounded border-primary-700/30" />
                <span className="text-foreground-400 text-xs font-body">Remember me</span>
              </label>
              <a href="#" className="text-primary-400 text-xs font-body hover:text-primary-300 transition-colors">
                Forgot password?
              </a>
            </div>

            <button
              type="submit"
              className="w-full py-3.5 bg-primary-500 text-background-50 font-label text-sm font-semibold tracking-wider uppercase rounded-full hover:bg-primary-400 transition-colors"
            >
              Sign In
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-primary-800/20 text-center">
            <p className="text-foreground-400 text-sm font-body">
              Don't have an account?{' '}
              <Link to="/signup" className="text-primary-400 hover:text-primary-300 transition-colors font-semibold">
                Open Account
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}